import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import FeedPage from "./pages/FeedPage";
import AuthPage from "./pages/AuthPage";
import ProfilePage from "./pages/ProfilePage";
import BrandsPage from "./pages/BrandsPage";
import BrandDetailPage from "./pages/BrandDetailPage";
import BookPromoPage from "./pages/BookPromoPage";
import CreateLookPage from "./pages/CreateLookPage";
import AffiliateAnalyticsPage from "./pages/AffiliateAnalyticsPage";
import AdminSubscribersPage from "./pages/AdminSubscribersPage";
import AdvertisePage from "./pages/AdvertisePage";
import RunwayToRealLifePage from "./pages/RunwayToRealLifePage";
import ChallengesPage from "./pages/ChallengesPage";
import ChallengeDetailPage from "./pages/ChallengeDetailPage";
import LookDetailPage from "./pages/LookDetailPage";
import BrandWeekPage from "./pages/BrandWeekPage";
import PPMPage from "./pages/PPMPage";
import HeirPage from "./pages/HeirPage";
import HeirDeckPage from "./pages/HeirDeckPage";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen bg-[#0a0a0a] noise-overlay">
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/feed" element={<FeedPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/profile/:username" element={<ProfilePage />} />
              <Route path="/brands" element={<BrandsPage />} />
              <Route path="/brands/:slug" element={<BrandDetailPage />} />
              <Route path="/book" element={<BookPromoPage />} />
              <Route path="/create" element={<CreateLookPage />} />
              <Route path="/analytics" element={<AffiliateAnalyticsPage />} />
              <Route path="/admin/subscribers" element={<AdminSubscribersPage />} />
              <Route path="/advertise" element={<Navigate to="/" replace />} />
              <Route path="/campaign/runway-to-real-life" element={<RunwayToRealLifePage />} />
              <Route path="/challenges" element={<ChallengesPage />} />
              <Route path="/challenges/:challengeId" element={<ChallengeDetailPage />} />
              <Route path="/look/:lookId" element={<LookDetailPage />} />
              <Route path="/one-brand-week" element={<BrandWeekPage />} />
              <Route path="/PPM" element={<PPMPage />} />
              <Route path="/ppm" element={<PPMPage />} />
              <Route path="/heir" element={<HeirPage />} />
              <Route path="/heir/deck" element={<HeirDeckPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </div>
    </AuthProvider>
  );
}

export default App;
